import axios from 'axios';
import { DomainService } from '@/libs'

// Don't change the order of creation
export function setupRouterGuard(router: any) {
  router.beforeEach((to: any, from: any, next: any) => {
    // @ts-ignore 每次路由切换都滚动到顶部
    document.querySelector('.main-container') && (document.querySelector('.main-container').scrollTop = 0);
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
      document.title = to.meta.title
    }

    // 如果当前的version和缓存不同，强制刷新一次浏览器
    // axios.get(`${DomainService.PublicPath}resource/version.json?v=${new Date().getTime()}`).then(function (response) {
    //   const localVersion = window.localStorage.getItem('md_engineer_client_version') || '0';
    //   const staticVersion = response.data || 0;
    //   window.localStorage.setItem('md_engineer_client_version', staticVersion);

    //   if (parseInt(localVersion, 10) !== parseInt(staticVersion, 10)) {
    //     // @ts-ignore
    //     // window.location.reload(true);
    //       const url = new URL(window.location.href);
    //       url.searchParams.set('forceReload', staticVersion);
    //       window.location.replace(url.toString());        
    //   }
      
    // });
    fetch(`${DomainService.PublicPath}resource/version.json?v=${new Date().getTime()}`)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      const localVersion = window.localStorage.getItem('md_engineer_client_version') || '0';
      const staticVersion = data || 0;
      window.localStorage.setItem('md_engineer_client_version', staticVersion);

      if (parseInt(localVersion, 10) !== parseInt(staticVersion, 10)) {
        // @ts-ignore
        // window.location.reload(true);
        const url = new URL(window.location.href);
        url.searchParams.set('forceReload', staticVersion);
        window.location.replace(url.toString());        
      }
    })
    .catch(error => {
      console.error('There was a problem with the fetch operation:', error);
    });

    next()
  })
}
